module.exports = __webpack_public_path__ + "static/images/practitioners-empty.279b81da157b34fffc35e2704ce3b0ea.svg";